/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @prettier
 */

import { createSpacing } from '@mui/system';

export const SPACING_PX = 8;

export const spacing = createSpacing(SPACING_PX);

export default spacing;
